import React, { useState, useEffect } from 'react';
import './PhoenixDashboard.css';

const PhoenixDashboard = () => {
  const [deploymentProgress, setDeploymentProgress] = useState(100);
  const [ollamaStatus, setOllamaStatus] = useState("Checking...");
  
  // Updated domain configuration
  const siteConfig = {
    domain: "phoenix-rising-creator360.web.app",
    url: "https://phoenix-rising-creator360.web.app",
    name: "Phoenix Rising - Creator360",
    status: "LIVE",
    projectId: "1067159240235"
  };

  // Check Ollama status on component mount
  useEffect(() => {
    const checkOllamaStatus = async () => {
      try {
        const response = await fetch('http://localhost:11434/api/tags');
        if (response.ok) {
          setOllamaStatus("Running");
        } else {
          setOllamaStatus("Error");
        }
      } catch (error) {
        setOllamaStatus("Offline");
      }
    };

    checkOllamaStatus();
  }, []);

  const deploymentStatus = [
    { name: "Frontend (React)", status: "Deployed", color: "success" },
    { name: "Backend (Firebase)", status: "Deployed", color: "success" },
    { name: "Database (Firestore)", status: "Deployed", color: "success" },
    { name: "Storage (Firebase)", status: "Deployed", color: "success" },
    { name: `Domain (${siteConfig.domain})`, status: "Active", color: "success" },
    { name: "SSL Certificate", status: "Active", color: "success" },
    { name: "Ollama AI Service", status: ollamaStatus, color: ollamaStatus === "Running" ? "success" : "warning" },
    { name: "AI Models (6 available)", status: "Ready", color: "success" }
  ];

  return (
    <div className="phoenix-dashboard">
      <header className="dashboard-header">
        <h1>🔥 Phoenix Rising</h1>
        <div className="site-info">
          <span className="site-url">{siteConfig.url}</span>
          <span className="site-status live">● {siteConfig.status}</span>
        </div>
      </header>

      <div className="deployment-section">
        <h2>🚀 Deployment Status</h2>
        
        <div className="progress-bar">
          <div className="progress-fill" style={{width: `${deploymentProgress}%`}}></div>
        </div>
        <p className="progress-text">Deployment Progress: {deploymentProgress}%</p>

        <div className="status-grid">
          {deploymentStatus.map((item, index) => (
            <div key={index} className="status-item">
              <span className="status-name">{item.name}</span>
              <span className={`status-badge ${item.color}`}>
                ✅ {item.status}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="phoenix-info">
        <h3>🌟 Phoenix is Live!</h3>
        <p>Your Creator360 platform is successfully deployed and running!</p>
        <div className="action-buttons">
          <a href={siteConfig.url} target="_blank" rel="noopener noreferrer" 
             className="visit-site-btn">
            🚀 Visit Phoenix Site
          </a>
          <button 
            onClick={() => {
              const testPrompt = "Write a short message about Phoenix Rising success";
              fetch('http://localhost:11434/api/generate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  model: 'llama3.2',
                  prompt: testPrompt,
                  stream: false
                })
              })
              .then(response => response.json())
              .then(data => {
                alert(`Ollama Test Success!\n\nResponse: ${data.response.substring(0, 100)}...`);
              })
              .catch(error => {
                alert(`Ollama Test Failed: ${error.message}`);
              });
            }}
            className="test-ollama-btn"
          >
            🦙 Test Ollama AI
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhoenixDashboard; 